import { CrudViewColumnType } from '../../../../../utils';

export const filterSupportedColumnTypes = [
  CrudViewColumnType.DateTime,
  CrudViewColumnType.Date,
  CrudViewColumnType.Text,
  CrudViewColumnType.Boolean,
  CrudViewColumnType.Rate,
  CrudViewColumnType.Number,
  CrudViewColumnType.Link
];
